import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class CobbledRoadTileEntity5 extends TileEntity {
	public static readonly frameName = FrameName.COBBLED_ROAD_5;
}

export default CobbledRoadTileEntity5;
